<template>
  <div
    :class="[$style.loader, customClass]"
    :style="loaderStyle"
  >
    <div :class="$style.loader__content" />
  </div>
</template>

<script>
export default {
  name: 'SearchLoader',
  props: {
    size: {
      type: Number,
      default: 18,
    },
    customClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    loaderStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
      };
    },
  },
};
</script>

<style module lang="less">
.loader {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  &__content {
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    &:before {
      content: '';
      position: absolute;
      inset: 0;
      box-sizing: border-box;
      border: 2px solid #E5E5E5;
      border-radius: 50%;
    }

    &:after {
      content: '';
      position: absolute;
      inset: 0;
      box-sizing: border-box;
      border: 2px solid transparent;
      border-top-color: #4C4C4C;
      border-right-color: #4C4C4C;
      border-bottom-color: #4C4C4C;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
